import type { User } from '@/types'

export const hasRequiredMemberName = (
  user: Pick<User, 'firstName' | 'lastName'> | null | undefined,
): boolean => !!user?.firstName?.trim() && !!user?.lastName?.trim()

